import { MessageCircle } from "lucide-react";
import { finalCta, site, waLink } from "@/content/siteContent";
import { Reveal } from "./Reveal";

export default function FinalCta() {
  return (
    <section className="relative overflow-hidden py-28 md:py-40" data-testid="final-cta-section">
      <div className="absolute inset-0">
        <img src={finalCta.image} alt="Fachada de edifício atendido pela Sagarelo" loading="lazy" className="h-full w-full object-cover" />
      </div>
      <div className="absolute inset-0 bg-ink/90" />
      <div className="absolute inset-0" style={{ background: "linear-gradient(90deg, rgba(13,13,15,.95), rgba(13,13,15,.6), rgba(13,13,15,.35))" }} />
      <div
        className="pointer-events-none absolute left-1/2 top-1/2 h-[420px] w-[420px] -translate-x-1/2 -translate-y-1/2 rounded-full opacity-20 blur-[120px]"
        style={{ background: "radial-gradient(circle, rgba(245,176,0,.55), transparent 65%)" }}
      />

      <div className="relative z-10 mx-auto max-w-4xl px-5 text-center md:px-8">
        <Reveal>
          <h2 className="font-display text-4xl font-extrabold leading-[1.02] tracking-tight text-paper sm:text-5xl lg:text-6xl" data-testid="final-cta-title">
            {finalCta.titleA}
            <br />
            PRECISA DE UMA <span className="text-brand">{finalCta.highlightWord}</span>
          </h2>
        </Reveal>
        <Reveal delay={0.12}>
          <p className="mx-auto mt-6 max-w-xl text-base leading-relaxed text-mist md:text-lg">{finalCta.text}</p>
        </Reveal>
        <Reveal delay={0.2}>
          <a
            href={waLink()}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-industrial mt-10 !px-9 !py-4 !text-[0.85rem]"
            data-testid="final-cta-button"
          >
            <MessageCircle className="h-5 w-5" />
            {finalCta.cta}
          </a>
        </Reveal>
        <Reveal delay={0.28}>
          <p className="mt-8 text-[0.68rem] font-bold tracking-[0.22em] text-steel">
            {site.schedule} <span className="mx-2 text-brand">•</span> {site.region}
          </p>
        </Reveal>
      </div>
    </section>
  );
}
